export const WORKLOAD_TITLE_INSIDE_TRUNCATE     = 1
export const WORKLOAD_TITLE_INSIDE_NO_TRUNCATE  = 2     // THIS IS NOT IN USE BUT KEEP IT (!)
export const WORKLOAD_TITLE_OUTSIDE             = 3